export default "__VITE_ASSET__BUFmx5sZ__"